import EFPicture, { PictureType } from 'elem/compCommon/EFPicture';
import EFButton from 'elem/compCommon/EFButton';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export type BannerProps = {
    title?: string | undefined;
    subtitle?: string | undefined;
    desc?: string | undefined;
    btnText?: string | undefined;
    isNotLink?: boolean;
    callback?: () => void;
    link?: string;
    theme?: string;
};

export type BannerType = Omit<PictureType, ''> & BannerProps;

export default function BannerStatic(props: BannerType) {
    const { src, srcPad = '', srcDesktop = '', srcMobile = '', theme, title, subtitle, desc, btnText, link, alt, isNotLink = false, callback, ...rest } = props;
    const { Link, gtm } = useGlobal();

    return (
        <div className={`${css.bannerStatic} banner-static`}>
            <EFPicture src={src} srcPad={srcPad} srcDesktop={srcDesktop} srcMobile={srcMobile} alt={alt || title} {...rest} />
            <div className={`banner-box ${theme}`}>
                {title && <h1 className="banner-title">{title}</h1>}
                {subtitle && <p className="banner-subtitle">{subtitle}</p>}
                {desc && <p className="banner-desc">{desc}</p>}
                {isNotLink && btnText && (
                    <div className="banner-btns" onClick={callback}>
                        <EFButton>{btnText}</EFButton>
                    </div>
                )}
                {!isNotLink && btnText && (
                    <>
                        {link?.startsWith('#') || link?.startsWith('.') ? (
                            <a
                                className="banner-btns"
                                href={link}
                                onClick={() =>
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'select_banner',
                                        banner_name: title,
                                        position: 'banner_1',
                                        button_name: btnText,
                                    })
                                }
                            >
                                {btnText}
                            </a>
                        ) : (
                            <Link
                                className="banner-btns"
                                href={link}
                                aria={title}
                                alt={title}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'select_banner',
                                    banner_name: title,
                                    position: 'banner_1',
                                    button_name: btnText,
                                }}
                            >
                                {btnText}
                            </Link>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
